<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-iranattacks-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-iranattacks-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.74712435841611;"
    data-aspect-ratio="0.747"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-iranattacks-xs-img"
      class="g-iranattacks-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranattacks-xs.jpg);"
    ></div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.5138%;margin-top:-14.5px;left:68.0513%;width:120px;"
    >
      <p class="g-pstyle6">US military bases</p>
      <p class="g-pstyle6">in the region</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.6917%;margin-top:-4.5px;left:89.4954%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle7">500km</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:17.0929%;margin-top:-7.5px;left:15.5074%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:23.6773%;margin-top:-14.6px;left:62.3821%;width:106px;"
    >
      <p class="g-pstyle2">US and Israeli</p>
      <p class="g-pstyle2">strikes</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:23.4321%;margin-top:-7.5px;left:6.6338%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.8281%;margin-top:-7.5px;left:32.3344%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:32.0541%;margin-top:-7.6px;left:75.2413%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:34.3182%;margin-top:-14.6px;left:8.8727%;width:122px;"
    >
      <p class="g-pstyle4">Iran&rsquo;s retaliatory</p>
      <p class="g-pstyle4">attacks</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:43.8082%;margin-top:-7.5px;right:44.606%;width:70px;"
    >
      <p class="g-pstyle5">Bahrain</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:51.2795%;margin-top:-7.5px;right:38.6242%;width:57px;"
    >
      <p class="g-pstyle5">Qatar</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:53.0907%;margin-top:-7.5px;left:67.1578%;margin-left:-22px;width:44px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:57.6187%;margin-top:-7.5px;left:79.3321%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle0">Oman</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:59.2035%;margin-top:-14.5px;left:39.5055%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.1312%;margin-top:-7.5px;left:85.9995%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">Turk.</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:74.3724%;margin-top:-7.5px;left:44.7297%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Yemen</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:16.4137%;margin-top:-7.5px;left:61.5442%;width:56px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:6.6784%;margin-top:-7.5px;left:10.0469%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-iranattacks-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.93089759326811;"
    data-aspect-ratio="0.931"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-iranattacks-sm-img"
      class="g-iranattacks-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranattacks-sm.jpg);"
    ></div>
    <div
      id="g-ai1-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:86.8149%;margin-top:-16.6px;left:67.3382%;width:136px;"
    >
      <p class="g-pstyle7">US military bases</p>
      <p class="g-pstyle7">in the region</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.5611%;margin-top:-6.5px;left:91.0859%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:20.9068%;margin-top:-6.5px;left:19.6577%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.7704%;margin-top:-17.7px;left:62.5044%;width:119px;"
    >
      <p class="g-pstyle2">US and Israeli</p>
      <p class="g-pstyle2">strikes</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:28.2079%;margin-top:-6.5px;left:93.6499%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">Afgh.</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:29.6682%;margin-top:-6.5px;left:5.1225%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:30.9459%;margin-top:-6.5px;left:34.2385%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:33.3339%;margin-top:-6.6px;left:69.7568%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.2619%;margin-top:-17.7px;left:17.1193%;width:137px;"
    >
      <p class="g-pstyle4">Iran&rsquo;s retaliatory</p>
      <p class="g-pstyle4">attacks</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:40.6199%;margin-top:-6.5px;left:8.1514%;width:70px;"
    >
      <p class="g-pstyle5">Jordan</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:51.5716%;margin-top:-6.5px;right:45.3703%;width:76px;"
    >
      <p class="g-pstyle6">Bahrain</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:55.0397%;margin-top:-6.5px;right:33.5848%;width:61px;"
    >
      <p class="g-pstyle6">Qatar</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:56.4928%;margin-top:-12.5px;left:31.4024%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:60.6981%;margin-top:-6.5px;left:67.7771%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:66.7215%;margin-top:-6.5px;left:76.1217%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Oman</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:84.6094%;margin-top:-6.5px;left:46.258%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle0">Yemen</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.9472%;margin-top:-6.5px;left:84.0196%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:18.899%;margin-top:-6.5px;left:61.3051%;width:60px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.5822%;margin-top:-6.5px;left:17.6497%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-iranattacks-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.96768265628866;"
    data-aspect-ratio="0.968"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-iranattacks-md-img"
      class="g-iranattacks-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranattacks-md.jpg);"
    ></div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.1509%;margin-top:-14.6px;left:82.6802%;width:128px;"
    >
      <p class="g-pstyle7">US military bases</p>
      <p class="g-pstyle7">in the region</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.5016%;margin-top:-8.2px;left:90.9081%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:20.3858%;margin-top:-8px;left:20.816%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.0136%;margin-top:-17.4px;left:60.9961%;width:112px;"
    >
      <p class="g-pstyle2">US and Israeli</p>
      <p class="g-pstyle2">strikes</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:27.7167%;margin-top:-8px;left:93.4846%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">Afgh.</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:29.6228%;margin-top:-8px;left:5.0701%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:30.5025%;margin-top:-8px;left:35.1281%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:33.0072%;margin-top:-8.1px;left:70.022%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:35.9836%;margin-top:-17.4px;left:18.319%;width:129px;"
    >
      <p class="g-pstyle4">Iran&rsquo;s retaliatory</p>
      <p class="g-pstyle4">attacks</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:38.8597%;margin-top:-8px;left:9.8759%;width:70px;"
    >
      <p class="g-pstyle5">Jordan</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:51.7622%;margin-top:-8px;right:44.8531%;width:76px;"
    >
      <p class="g-pstyle6">Bahrain</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:55.1344%;margin-top:-8px;right:33.2672%;width:61px;"
    >
      <p class="g-pstyle6">Qatar</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:56.6853%;margin-top:-15.6px;left:32.3498%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:60.9991%;margin-top:-8px;left:68.0769%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:67.0105%;margin-top:-8px;left:76.2666%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Oman</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:7.0435%;margin-top:-8px;left:84.0394%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:85.3378%;margin-top:-8px;left:46.9413%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle0">Yemen</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:18.1865%;margin-top:-8px;left:61.7222%;width:60px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:6.7503%;margin-top:-8px;left:18.8422%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-iranattacks-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.25183575383668;"
    data-aspect-ratio="1.252"
    data-min-width="930"
  >
    <div
      id="g-iranattacks-lg-img"
      class="g-iranattacks-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/iranattacks-lg.jpg);"
    ></div>
    <div
      id="g-ai3-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:76.411%;margin-top:-16.7px;left:73.3444%;width:143px;"
    >
      <p class="g-pstyle7">US military bases</p>
      <p class="g-pstyle7">in the region</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.2726%;margin-top:-9.2px;left:92.59%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:19.9326%;margin-top:-9.1px;left:21.1175%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:25.8047%;margin-top:-19.7px;left:53.7308%;width:125px;"
    >
      <p class="g-pstyle2">US and Israeli</p>
      <p class="g-pstyle2">strikes</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:26.7975%;margin-top:-9.1px;left:83.5739%;margin-left:-56px;width:112px;"
    >
      <p class="g-pstyle0">Afghanistan</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:30.028%;margin-top:-9.1px;left:31.785%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:30.9703%;margin-top:-9.1px;left:6.9924%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:33.2753%;margin-top:-9.2px;left:61.04%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:36.304%;margin-top:-19.7px;left:19.0681%;width:144px;"
    >
      <p class="g-pstyle4">Iran&rsquo;s retaliatory</p>
      <p class="g-pstyle4">attacks</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:39.3159%;margin-top:-9.1px;left:12.2104%;width:73px;"
    >
      <p class="g-pstyle5">Jordan</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:52.9111%;margin-top:-9.1px;right:51.0398%;width:80px;"
    >
      <p class="g-pstyle6">Bahrain</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:56.5454%;margin-top:-9.1px;right:41.6114%;width:64px;"
    >
      <p class="g-pstyle6">Qatar</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:58.1166%;margin-top:-17.8px;left:30.4433%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:62.6027%;margin-top:-9.1px;left:59.4897%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:69.0638%;margin-top:-9.1px;left:66.0863%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">Oman</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:5.9336%;margin-top:-9.1px;left:72.4435%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:88.1778%;margin-top:-9.1px;left:42.307%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Yemen</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:17.5209%;margin-top:-9.2px;left:54.3205%;width:69px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-whiteshadow g-aiAbs g-aiPointText"
      style="top:4.8567%;margin-top:-9.1px;left:7.3211%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-01 12:53 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-01 12:53 -->
<!-- ai file: iranattacks.ai -->
<style lang="scss">
  #g-iranattacks-box {
    container-type: inline-size;
    container-name: g-iranattacks-box;
  }
  #g-iranattacks-box,
  #g-iranattacks-box .g-artboard {
    margin: 0 auto;
  }
  #g-iranattacks-box p {
    margin: 0;
  }
  #g-iranattacks-box .g-aiAbs {
    position: absolute;
  }
  #g-iranattacks-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-iranattacks-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-iranattacks-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-iranattacks-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-iranattacks-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-iranattacks-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-iranattacks-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-iranattacks-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-iranattacks-lg {
        display: block !important;
      }
    }
  }
  #g-iranattacks-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-iranattacks-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-iranattacks-xs .g-pstyle0 {
    font-weight: 300;
    height: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-iranattacks-xs .g-pstyle1 {
    font-weight: 300;
    height: 14px;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-xs .g-pstyle2 {
    font-weight: 700;
    height: 14px;
    font-size: 14px;
    color: rgb(165, 15, 21);
  }
  #g-iranattacks-xs .g-pstyle3 {
    font-weight: 700;
    height: 14px;
    letter-spacing: 0.1em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-xs .g-pstyle4 {
    font-weight: 700;
    height: 14px;
    font-size: 14px;
    color: rgb(0, 51, 102);
  }
  #g-iranattacks-xs .g-pstyle5 {
    font-weight: 300;
    height: 14px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-iranattacks-xs .g-pstyle6 {
    font-weight: 700;
    height: 14px;
    font-size: 13px;
  }
  #g-iranattacks-xs .g-pstyle7 {
    font-weight: 300;
    line-height: 8px;
    height: 8px;
    text-align: center;
  }
  #g-iranattacks-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-iranattacks-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-iranattacks-sm .g-pstyle0 {
    font-weight: 400;
    height: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-iranattacks-sm .g-pstyle1 {
    font-weight: 500;
    height: 12px;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
    color: rgb(165, 15, 21);
  }
  #g-iranattacks-sm .g-pstyle3 {
    font-weight: 900;
    height: 12px;
    letter-spacing: 0.27em;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
    color: rgb(0, 51, 102);
  }
  #g-iranattacks-sm .g-pstyle5 {
    font-weight: 400;
    height: 12px;
    text-transform: uppercase;
  }
  #g-iranattacks-sm .g-pstyle6 {
    font-weight: 400;
    height: 12px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-iranattacks-sm .g-pstyle7 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 15px;
  }
  #g-iranattacks-sm .g-pstyle8 {
    font-weight: 400;
    height: 12px;
    text-align: center;
  }
  #g-iranattacks-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-iranattacks-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-iranattacks-md .g-pstyle0 {
    font-weight: 400;
    height: 15px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-iranattacks-md .g-pstyle1 {
    font-weight: 500;
    height: 15px;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-md .g-pstyle2 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    color: rgb(165, 15, 21);
  }
  #g-iranattacks-md .g-pstyle3 {
    font-weight: 900;
    height: 15px;
    letter-spacing: 0.27em;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-md .g-pstyle4 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    font-size: 15px;
    color: rgb(0, 51, 102);
  }
  #g-iranattacks-md .g-pstyle5 {
    font-weight: 400;
    height: 15px;
    text-transform: uppercase;
  }
  #g-iranattacks-md .g-pstyle6 {
    font-weight: 400;
    height: 15px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-iranattacks-md .g-pstyle7 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
    font-size: 14px;
  }
  #g-iranattacks-md .g-pstyle8 {
    font-weight: 400;
    height: 15px;
    text-align: center;
  }
  #g-iranattacks-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-iranattacks-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-iranattacks-lg .g-pstyle0 {
    font-weight: 400;
    height: 17px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-iranattacks-lg .g-pstyle1 {
    font-weight: 500;
    height: 17px;
    font-size: 16px;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-lg .g-pstyle2 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 17px;
    color: rgb(193, 18, 31);
  }
  #g-iranattacks-lg .g-pstyle3 {
    font-weight: 900;
    height: 17px;
    letter-spacing: 0.27em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-iranattacks-lg .g-pstyle4 {
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 17px;
    color: rgb(0, 51, 102);
  }
  #g-iranattacks-lg .g-pstyle5 {
    font-weight: 400;
    height: 17px;
    text-transform: uppercase;
  }
  #g-iranattacks-lg .g-pstyle6 {
    font-weight: 400;
    height: 17px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-iranattacks-lg .g-pstyle7 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    font-size: 16px;
  }
  #g-iranattacks-lg .g-pstyle8 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-gouda($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 0.9);
    text-shadow:
      1px 1px 1px rgba($clr, $alpha),
      1px -1px 1px rgba($clr, $alpha),
      -1px 1px 1px rgba($clr, $alpha),
      -1px -1px 1px rgba($clr, $alpha);
  }
  .g-whiteshadow {
    @include shadow-gouda(#ffffff);
  }
</style>
